/**
 * SendLogRequest
 *
 * Module to firing logging events.
 *
 * @param  {string} name [name of the log event]
 * @param  {string} type [type of log event]
 * @param  {object} data [data to log]
 *
 * @return {function}
 */

OT.createNS('OT.Common.sendLogRequest');

OT.Common.sendLogRequest = function(name, data, callback) {
    'use strict';

    callback = callback || function() {};

    // Check if all logging has been disabled
    if (!OT.Common.Config.get('EnableAllLogging')) {
        return false;
    }

    if (!name) {
        throw new Error('OTLogEvent: No log name passed');
    }

    var defaults = {
        commonConfig: OT.Common.Config.getAll(),
        sessionKey: OT.Common.Helpers.getSessionKey(),
        pageId: OT.Common.Helpers.getPageId(),
        requestId: OT.Common.Helpers.getRequestId() || OT.Common.Helpers.generateGUID(),
        timeFromPageLoad: OT.Common.Helpers.getTimeFromPageLoad()
    };

    var logData = _.extend(defaults, data || {});
    var headers = OT.Common.Helpers.buildRequestHeaders();

    // Fire request and forget
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/s/node/api/log',
        headers: headers,
        data: JSON.stringify({
            'logName': name, // TODO: This looks like 'logname', another logged attribute
            'Data': logData,
            'url': window.location.pathname
        })
    }).always(function() {
        callback(logData);
    });
};
